import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
// import BillPaymentReportDrawer from "components/drawer/BillPaymentReportDrawer";

// import Tooltip from "components/tooltip/Tooltip";
import Tooltip from "@mui/material/Tooltip";
import React, { useState } from "react";

const BillPaymentReportTable = ({
  billpaymentreport,
  perpage,
  currentPage,
  tab,
}) => {
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
  const [selectedPaymentHistory, setSelectedPaymentHistory] = useState([]);
  const [selectedClientName, setSelectedClientName] = useState("");
  const [selectedRefNo, setSelectedRefNo] = useState("");
  const [tripAdvancehistoryData, setTripAdvancehistoryData] = useState(null);
  const [isTripAdvanceModalOpen, setisTripAdvanceModalOpen] = useState(false);

  const handleOpenPaymentModal = (data) => {
    setSelectedPaymentHistory(
      Array.isArray(data.payment_history) ? data.payment_history : [],
    );

    setSelectedClientName(data.client_name || "");
    setSelectedRefNo(data.ref_no || "");

    setIsPaymentModalOpen(true);
  };

  const handleClosePaymentModal = () => {
    setIsPaymentModalOpen(false);
    setSelectedPaymentHistory([]);
    setSelectedClientName("");
    setSelectedRefNo("");
  };

  const getStatusText = (data) => {
    if (data.paid_status === "1") {
      return "PAID";
    } else if (
      data.paid_status === "0" &&
      Number(data.remaining_individual_amt) < 0
    ) {
      return "Overpaid";
    } else if (data.bill_verify_satus === "0" && !data.bill_added_date) {
      return "Not Submitted";
    } else if (data.bill_verify_satus === "0") {
      return "Awaiting for Bill Verification";
    } else if (data.bill_approval_status === "0") {
      return "Awaiting for Bill Approval";
    } else if (data.bill_adjusted_status === "0") {
      return "Awaiting for Financial Approval";
    } else if (Number(data.total_paid_amount) > 0) {
      return "PARTIALLY PAID";
    } else if (data.paid_status === "0") {
      return "Awaiting for Payment";
    }
    return "Unknown Status";
  };
  const getStatusColor = (data) => {
    const status = getStatusText(data);
    switch (status) {
      case "PAID":
        return "text-green-500";
      case "PARTIALLY PAID":
        return "text-orange-500";
      case "Not Submitted":
        return "text-red-500";
      case "Awaiting for Bill Verification":
        return "text-yellow-500";
      case "Awaiting for Bill Approval":
        return "text-orange-500";
      case "Awaiting for Financial Approval":
        return "text-purple-500";
      case "Awaiting for Payment":
        return "text-blue-500";
      case "Overpaid":
        return "text-orange-500";
      default:
        return "text-gray-500";
    }
  };

  return (
    <>
      <TableBody>
        {billpaymentreport.slice(0, perpage).map((data, index) => (
          <TableRow
            key={data.va_id}
            className={
              Number(data.booking_status) === 1
                ? "bg-red-100 dark:bg-red-900"
                : ""
            }
          >
            <TableCell className="text-sm text-center">
              {(currentPage - 1) * perpage + index + 1}
            </TableCell>

            <TableCell className="text-sm text-center">{data.ref_no}</TableCell>

            <TableCell className="text-sm text-center">
              {data.client_name}
            </TableCell>

            <TableCell className="text-sm text-center">
              <p className="flex flex-col m-0">
                <span>{data.start_date}</span>
                <span>{data.end_date}</span>
              </p>
            </TableCell>

            {/* <TableCell className="text-sm text-center">
							{data.arrival}
						</TableCell> */}

            <TableCell className="text-sm text-center">
              {data.vendor_name}
            </TableCell>
            {/* 
						<TableCell className="text-sm text-center">
							<div
								dangerouslySetInnerHTML={{
									__html: data.trip_date,
								}}
							></div>
						</TableCell> */}

            <TableCell className="text-sm text-center">
              {data.bill_amount}
            </TableCell>

            <TableCell className="text-sm text-center">{data.tds}</TableCell>

            <TableCell className="text-sm text-center">
              {data.total_trip_advance_paid}
              {data?.total_trip_advance_paid > 0 && (
                <p
                  className="text-blue-500 text-sm underline cursor-pointer"
                  onClick={() => {
                    setTripAdvancehistoryData(data);
                    setisTripAdvanceModalOpen(true);
                  }}
                >
                  View
                </p>
              )}
            </TableCell>

            {/* <TableCell className="text-sm text-center">
              {data.payment_history?.length > 0
                ? data.payment_history.map((payment, index) => {
                    const amount =
                      Number(payment.adjusted_amount) > 0
                        ? Number(payment.adjusted_amount)
                        : Number(payment.amount) > 0
                          ? Number(payment.amount)
                          : 0;

                    return (
                      <div key={index} className="text-green-500">
                        {amount > 0 ? (
                          <>
                            <span >
                              {payment.payment_type?.toLowerCase() === "cash"
                                ? "Cash"  
                                : "Adjusted Amount"}
                            </span>
                            {" : "}
                            {amount}
                          </>
                        ) : (
                          "-"
                        )}
                      </div>
                    );
                  })
                : "-"}
            </TableCell> */}

            {data.paid_status === "0" ? (
              <TableCell className="text-sm text-center">
                {Number(data.remaining_individual_amt) < 0 ? (
                  <span className="text-orange-500">
                    Overpaid (₹{Math.abs(Number(data.remaining_individual_amt))}
                    )
                  </span>
                ) : (
                  data.remaining_individual_amt || "-"
                )}
              </TableCell>
            ) : (
              <TableCell className="text-sm text-center">
                {data.paid_amount}
              </TableCell>
            )}

            <TableCell className="text-sm text-center">
              <span className={`${getStatusColor(data)}`}>
                {getStatusText(data)}
              </span>
            </TableCell>
            {/* 
            <TableCell className="text-sm text-center">
              {Array.isArray(data.payment_history) &&
              data.payment_history.length > 0 ? (
                <Tooltip
                  title={
                    <div className="text-sm">
                      {data.payment_history.map((entry, i) => {
                        const directAmount = Number(entry.amount) || 0;
                        const adjustedAmount =
                          Number(entry.adjusted_amount) || 0;
                        const total = directAmount + adjustedAmount;
                        return (
                          <div
                            key={i}
                            className={
                              i > 0 ? "mt-2 pt-2 border-t border-gray-400" : ""
                            }
                          >
                            <div className="mb-1">
                              <strong>{entry.type}:</strong> ₹{total}
                              {adjustedAmount > 0 && directAmount > 0 && (
                                <span className="text-xs text-gray-300">
                                  {" "}
                                  (₹{directAmount} paid + ₹{adjustedAmount}{" "}
                                  outstanding adj.)
                                </span>
                              )}
                            </div>
                            <div className="mb-1">
                              <strong>Date:</strong>{" "}
                              {entry.paid_date
                                ? new Date(entry.paid_date).toLocaleDateString(
                                    "en-GB",
                                  )
                                : "N/A"}
                            </div>
                            {directAmount > 0 && (
                              <>
                                <div className="mb-1">
                                  <strong>Type:</strong>{" "}
                                  {entry.payment_type || "N/A"}
                                </div>
                                {entry.utr && (
                                  <div className="mb-1">
                                    <strong>UTR:</strong> {entry.utr}
                                  </div>
                                )}
                              </>
                            )}
                            {adjustedAmount > 0 && (
                              <div className="mt-1">
                                <strong className="text-yellow-300">
                                  {directAmount > 0
                                    ? "Outstanding Adjustment: ₹"
                                    : "Paid via Outstanding Adjustment: ₹"}
                                  {entry.adjusted_amount}
                                </strong>
                                {(entry.adjustments || []).map(
                                  (adj, adjIdx) => (
                                    <div key={adjIdx} className="text-xs">
                                      + ₹{adj.adjusted_amount} from{" "}
                                      {adj.ref_no || "booking"}
                                      {adj.client_name
                                        ? ` (${adj.client_name})`
                                        : ""}
                                    </div>
                                  ),
                                )}
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  }
                  placement="top-start"
                  arrow
                >
                  <span className="text-blue-600 cursor-pointer">View</span>
                </Tooltip>
              ) : (
                <span className="text-gray-400">-</span>
              )}
            </TableCell> */}

            <TableCell className="text-sm text-center">
              {Array.isArray(data.payment_history) &&
              data.payment_history.length > 0 ? (
                <span
                  className="text-blue-600 cursor-pointer hover:underline"
                  onClick={() => handleOpenPaymentModal(data)}
                >
                  View
                </span>
              ) : (
                <span className="text-gray-400">-</span>
              )}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>

      {/* PAYMENT HISTORY MODAL */}
      {isPaymentModalOpen && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 px-4"
          onClick={handleClosePaymentModal}
        >
          <div
            style={{ maxHeight: "75vh", overflowY: "auto" }}
            className="bg-white dark:bg-gray-800 rounded-lg shadow-xl w-full max-w-2xl max-h-[75vh] overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            {/* HEADER */}
            <div className="flex justify-end px-4 pt-2">
              <button
                type="button"
                onClick={handleClosePaymentModal}
                className="text-gray-500 hover:text-gray-700 text-end text-2xl"
              >
                ×
              </button>
            </div>

            <div>
              <h2 className="text-lg font-semibold text-center">
                Payment History
              </h2>
            </div>

            {/* BODY */}
            <div className="p-6 overflow-y-auto max-h-[65vh]">
              {selectedPaymentHistory?.map((entry, i) => {
                const cashAmount = Number(entry.amount) || 0;
                const adjustedAmount = Number(entry.adjusted_amount) || 0;

                return (
                  <div key={i} className={i > 0 ? "mt-5 pt-5 border-t" : ""}>
                    {/* PAYMENT TYPE */}
                    <div className="flex justify-between mb-4">
                      <div>
                        <div className="text-xs text-gray-500">Payment</div>

                        <div className="font-semibold">
                          {entry.type || "Payment"}
                        </div>
                      </div>
                    </div>

                    {/* DATE + PAYMENT TYPE */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm">
                      {/* DATE */}
                      <div>
                        <div className="text-gray-500">Date</div>

                        <div>
                          {entry.paid_date
                            ? new Date(entry.paid_date).toLocaleDateString(
                                "en-GB",
                              )
                            : "N/A"}
                        </div>
                      </div>

                      {/* PAYMENT TYPE */}
                      {cashAmount > 0 && (
                        <div>
                          <div className="text-gray-500">Payment Type</div>

                          <div>{entry.payment_type || "N/A"}</div>
                        </div>
                      )}
                    </div>

                    {/* CASH AMOUNT */}
                    {cashAmount > 0 && (
                      <div className="mt-4">
                        <div className="text-xs text-gray-500">
                          Cash Amount :{" "}
                          <span className="font-semibold text-green-500">
                            ₹{cashAmount}
                          </span>
                        </div>
                      </div>
                    )}

                    {/* UTR */}
                    {cashAmount > 0 && entry.utr && (
                      <div className="mt-3 text-sm">
                        <div className="text-gray-500">UTR : </div>

                        <div>{entry.utr}</div>
                      </div>
                    )}

                    {/* ADJUSTED AMOUNT */}
                    {adjustedAmount > 0 && (
                      <div className="mt-4  bg-yellow-50 border border-yellow-200 rounded p-4">
                        <div className="font-semibold text-yellow-700">
                          Adjusted Amount:{" "}
                          <span className="font-bold">₹{adjustedAmount}</span>
                        </div>

                        {/* ADJUSTMENT DETAILS */}
                        {(entry.adjustments || []).map((adj, adjIdx) => (
                          <div key={adjIdx} className="mt-2 text-xs">
                            <div className="mb-2">
                              Amount: ₹{adj.adjusted_amount}
                            </div>

                            <div className="mb-2">
                              Booking Id: {adj.ref_no || "N/A"}
                            </div>

                            <div className="mb-2">
                              Client Name: {adj.client_name || "N/A"}
                            </div>
                          </div>
                        ))}
                      </div>
                    )}

                    {/* NO AMOUNT */}
                    {cashAmount === 0 && adjustedAmount === 0 && (
                      <div className="mt-4 text-sm text-gray-500">
                        No payment amount available
                      </div>
                    )}
                  </div>
                );
              })}

              {/* NO HISTORY */}
              {(!selectedPaymentHistory ||
                selectedPaymentHistory.length === 0) && (
                <div className="text-center text-gray-500 py-6">
                  No payment history found.
                </div>
              )}
            </div>

            {/* FOOTER */}
            <div className="flex justify-end px-6 py-4 border-t">
              <button
                type="button"
                onClick={handleClosePaymentModal}
                className="px-4 py-2 text-sm font-medium text-white bg-green-600 hover:bg-green-700 rounded-md"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {isTripAdvanceModalOpen && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 px-4"
          onClick={() => setisTripAdvanceModalOpen(false)}
        >
          <div
            style={{ maxHeight: "75vh", overflowY: "auto" }}
            className="bg-white dark:bg-gray-800 rounded-lg shadow-xl w-full max-w-2xl max-h-[75vh] overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            {/* HEADER */}
            <div className="flex justify-end px-4 pt-2">
              <button
                type="button"
                onClick={() => setisTripAdvanceModalOpen(false)}
                className="text-gray-500 hover:text-gray-700 text-end text-2xl cursor-pointer"
              >
                ×
              </button>
            </div>

            <div>
              <div>
                <h2 className="text-lg font-semibold text-center">
                  Trip Advance History
                </h2>
              </div>
            </div>

            {/* BODY */}
            <div className="p-6 overflow-y-auto h-65vh max-h-[65vh]">
              {tripAdvancehistoryData?.payment_history
                ?.filter((entry) => entry.type === "Trip Advance")
                .map((entry, i) => {
                  const directAmount = Number(entry.amount) || 0;
                  const adjustedAmount = Number(entry.adjusted_amount) || 0;

                  return (
                    <div key={i} className={i > 0 ? "mt-5 pt-5 border-t" : ""}>
                      {/* PAYMENT HEADER */}
                      <div className="flex justify-between mb-3">
                        <div>
                          <div className="text-xs text-gray-500">Payment</div>

                          <div className="font-semibold">
                            {entry.type || "Payment"}
                          </div>
                        </div>
                      </div>

                      {/* DETAILS */}
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm">
                        {/* DATE */}
                        <div>
                          <div className="text-gray-500">Date</div>

                          <div>
                            {entry.paid_date
                              ? new Date(entry.paid_date).toLocaleDateString(
                                  "en-GB",
                                )
                              : "N/A"}
                          </div>
                        </div>

                        {/* CASH AMOUNT */}
                        {directAmount > 0 && (
                          <div>
                            <div className="text-gray-500">Amount</div>

                            <div className="font-semibold text-green-600">
                              ₹{directAmount}
                            </div>
                          </div>
                        )}

                        {/* PAYMENT TYPE */}
                        {directAmount > 0 && (
                          <div>
                            <div className="text-gray-500">Payment Type</div>

                            <div>{entry.payment_type || "N/A"}</div>
                          </div>
                        )}
                      </div>

                      {/* UTR */}
                      {directAmount > 0 && entry.utr && (
                        <div className="mt-3 text-sm">
                          <div className="text-gray-500">UTR</div>
                          <div>{entry.utr}</div>
                        </div>
                      )}

                      {/* ADJUSTED AMOUNT */}
                      {adjustedAmount > 0 && (
                        <div className="mt-4 bg-yellow-50 border border-yellow-200 rounded p-4">
                          <div className="font-semibold text-yellow-700">
                            Adjusted Amount:{" "}
                            <span className="font-bold">₹{adjustedAmount}</span>
                          </div>

                          {/* ADJUSTMENT DETAILS */}
                          {(entry.adjustments || []).map((adj, adjIdx) => (
                            <div key={adjIdx} className="mt-2 text-xs">
                              <div className="mb-2">
                                Amount: ₹{adj.adjusted_amount}
                              </div>

                              <div className="mb-2">
                                Booking Id: {adj.ref_no || "N/A"}
                              </div>

                              <div className="mb-2">
                                Client Name: {adj.client_name || "N/A"}
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  );
                })}

              {/* NO TRIP ADVANCE DATA */}
              {(!tripAdvancehistoryData?.payment_history ||
                !tripAdvancehistoryData.payment_history.some(
                  (entry) => entry.type === "Trip Advance",
                )) && (
                <div className="text-center text-gray-500 py-6">
                  No Trip Advance history found.
                </div>
              )}
            </div>

            {/* FOOTER */}
            <div className="flex justify-end px-6 py-4 border-t">
              <button
                type="button"
                onClick={() => setisTripAdvanceModalOpen(false)}
                className="px-4 py-2 text-sm font-medium text-white bg-green-600 hover:bg-green-700 rounded-md"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default BillPaymentReportTable;
